export default __webpack_public_path__ + "static/media/image16.92847e00.png";